import { render } from "./DeleteMyAccount.vue?vue&type=template&id=61d13540&scoped=true&ts=true"
import script from "./DeleteMyAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteMyAccount.vue?vue&type=script&lang=ts"

import "./DeleteMyAccount.vue?vue&type=style&index=0&id=61d13540&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d13540"]])

export default __exports__